<template>
  <div class="q-pa-md">
    <q-banner rounded class="bg-grey-2">
      Мастер старых report-document форм больше не используется. Откройте каталог отчетов и сформируйте отчет по новому контракту.
      <template v-slot:action>
        <q-btn flat color="primary" label="К списку отчетов" @click="$router.replace({ name: 'reports_list' })" />
      </template>
    </q-banner>
  </div>
</template>

<script>
export default {
  name: 'ReportsMasterArchive',
  mounted() {
    this.$router.replace({ name: 'reports_list' }).catch(() => {})
  }
}
</script>
